import { FlightData, SimpleFlight, GoogleAddressAndFlightData, GoogleAddress } from 'app-types';
import { isNil, get, isEmpty } from 'lodash-es';

export const isFlightItem = (item: object): item is FlightData => {
	return 'flightNumber' in item;
};

export const isFlightAddress = (item: object): item is GoogleAddress => {
	return 'flight' in item;
};

export const hasFlight = (item?: object): item is { flight: SimpleFlight } => {
	return !isNil(get(item, 'flight'));
};

export const getPlaceId = (
	item: GoogleAddressAndFlightData,
	isPickup?: boolean,
	airportType?: string
) => {
	if (isFlightItem(item)) {
		if (airportType) {
			return airportType === 'arrival' ? item.arrivalPlaceId : item.departurePlaceId;
		}
		return isPickup ? item.arrivalPlaceId : item.departurePlaceId;
	}
	return item.placeId;
};

export const getPlaceAddress = (
	item: GoogleAddressAndFlightData,
	isPickup?: boolean,
	airportType?: string
) => {
	if (isFlightItem(item)) {
		if (airportType) {
			return airportType === 'arrival'
				? item.arrivalAirportAddress
				: item.departureAirportAddress;
		}
		return isPickup ? item.arrivalAirportAddress : item.departureAirportAddress;
	}
	return item.fullAddress;
};

export const getAirportCorrectedAddress = (
	item: GoogleAddressAndFlightData,
	isPickup?: boolean,
	airportType?: string
) => {
	if (isFlightItem(item)) {
		if (airportType) {
			return airportType === 'arrival' ? item.arrivalAddress : item.departureAddress;
		}
		return isPickup ? item.arrivalAddress : item.departureAddress;
	}
	return item.fullAddress;
};

export const isNoFlights = (addressesSuggestions?: GoogleAddressAndFlightData[]) => {
	// in case of flight we can have only one suggestion

	const firstSuggestion =
		addressesSuggestions && !isEmpty(addressesSuggestions) ? addressesSuggestions[0] : {};

	return isFlightItem(firstSuggestion) && firstSuggestion.isFlightError;
};

export const isEnoughLettersForSearch = (value?: string) => {
	return value && value.length >= 3;
};
